export class Client {
  constructor(public version: string, public name: string) {
  }
}
